import { SaveButtonBaseProps, SaveButtonState } from '../SaveButtonProps';
import SaveButtonBase from '../subcomponents/SaveButtonBase';
import { getDataLinkEventSaveUnsave } from '../_helpers/saveButtonHelpers';
import { useComponentContext } from '../../_helpers/componentContext.tsx';

export type SavedPageVariantProps = SaveButtonBaseProps;

/**
 * Save Button variant for Saved Page:
 * - it does nothing but block the double click
 */
const SavedPageVariant: React.FC<SavedPageVariantProps> = (props) => {
	const componentName = useComponentContext().componentName;
	const onButtonClick = () => {
		if (props.buttonState === SaveButtonState.SAVED) {
			props.onClick?.();
		}
	};

	return (
		<SaveButtonBase
			{...props}
			onClick={onButtonClick}
			saveDataLinkEvent={getDataLinkEventSaveUnsave(
				componentName,
				SaveButtonState.SAVED,
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				props.item
			)}
		/>
	);
};

export default SavedPageVariant;
